import { Link } from 'react-router-dom';

export interface AdminNavItem {
  key: string;
  label: string;
  icon: string;
}

export const adminNavItems: AdminNavItem[] = [
  { key: 'overview', label: 'Tableau de bord', icon: 'ri-dashboard-line' },
  { key: 'users', label: 'Utilisateurs', icon: 'ri-user-3-line' },
  { key: 'ads', label: 'Publicités', icon: 'ri-megaphone-line' },
  { key: 'campaigns', label: 'Campagnes pub', icon: 'ri-bill-line' },
  { key: 'content', label: 'Contenus', icon: 'ri-folders-line' },
  { key: 'reports', label: 'Signalements', icon: 'ri-flag-2-line' },
];

interface AdminSidebarProps {
  active: string;
  onSelect: (key: string) => void;
}

function AdminSidebar({ active, onSelect }: AdminSidebarProps) {
  return (
    <aside className="w-full lg:w-64 shrink-0">
      <div className="bg-background-100 border border-background-200/70 rounded-xl p-3 lg:sticky lg:top-24">
        <div className="flex items-center gap-3 px-3 py-3 mb-2">
          <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/10">
            <i className="ri-admin-line text-lg text-primary-400" />
          </div>
          <div>
            <span className="block text-sm font-semibold text-foreground-50">Administration</span>
            <span className="block text-xs text-foreground-400">WorldApeiron</span>
          </div>
        </div>

        <nav className="space-y-1">
          {adminNavItems.map((item) => (
            <button
              key={item.key}
              onClick={() => onSelect(item.key)}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors text-left whitespace-nowrap ${
                active === item.key
                  ? 'bg-primary-500/10 text-primary-400'
                  : 'text-foreground-500 hover:text-foreground-50 hover:bg-background-200/60'
              }`}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-base`} />
              </span>
              {item.label}
            </button>
          ))}
        </nav>

        <div className="mt-4 pt-4 border-t border-background-200/70">
          <Link
            to="/"
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-500 hover:text-foreground-50 hover:bg-background-200/60 transition-colors"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line text-base" />
            </span>
            Retour au site
          </Link>
        </div>
      </div>
    </aside>
  );
}

export default AdminSidebar;